import type { ReactElement } from 'react'

import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import { FormSubmitButton } from '@twisto/components/atoms/button'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import { useForm } from '@twisto/components/atoms/form'

import { FlowForm } from '../flow-form'
import { submittingFlowFormAtom } from '../submitting-atom'

type Props = {
  buttonText?: ReactElement | string
  onSubmit: CastedSubmitHandler<Record<string, never>>
  className?: string
}

export const FlowFormSubmitButton = ({
  onSubmit,
  buttonText,
  className,
}: Props) => {
  const [submitting] = useAtom(submittingFlowFormAtom)
  const formContext = useForm({
    defaultValues: {},
  })

  return (
    <div className={className}>
      <FlowForm {...formContext} onSubmit={onSubmit}>
        <FormSubmitButton fullWidth disabled={submitting}>
          {buttonText ?? (
            <Trans id="flow.components.flowFormSubmitButton.default" />
          )}
        </FormSubmitButton>
      </FlowForm>
    </div>
  )
}
